const {
    ROOT_BASKET_TYPES,
    MAIN_BASKET_TYPES: { DC_BASKET, BOPIS_BASKET },
    DC_BASKET_TYPES: { SAMEDAY_BASKET, AUTOREPLENISH_BASKET, STANDARD_BASKET }
} = require('constants/RwdBasket');

function getPickupFromStoreInfo({ pickupBasket }) {
    const { isROPISEnabled, isBOPISEnabled } = Sephora.configurationSettings;
    const bopisIsEnabled = isROPISEnabled || isBOPISEnabled;

    if (pickupBasket == null) {
        return {
            isAvailable: false
        };
    }

    const { items, pickupMessage, storeDetails } = pickupBasket;

    return {
        isAvailable: bopisIsEnabled && items.length > 0,
        items,
        pickupMessage,
        storeDetails
    };
}

function getSameDayDeliveryInfo({ itemsByBasket }) {
    const { isSameDayShippingEnabled } = Sephora.configurationSettings;
    const sdd = itemsByBasket?.find(e => e.basketType === SAMEDAY_BASKET);

    if (sdd == null) {
        return {
            isAvailable: false
        };
    }

    const { items, sameDayDeliveryMessage, sameDayTitle } = sdd;

    return { items, isAvailable: isSameDayShippingEnabled, sameDayDeliveryMessage, sameDayTitle };
}

function getStandardShippingInfo({ itemsByBasket, remainToFreeShipping }) {
    const standard = itemsByBasket?.find(e => e.basketType === STANDARD_BASKET);
    const standardFiltered = standard?.items.filter(item => !item.isReplenishment);

    if (standard == null || standardFiltered.length === 0) {
        return { isAvailable: false };
    }

    return { items: standardFiltered, isAvailable: true, remainToFreeShipping };
}

function getAutoreplenishInfo({ itemsByBasket }) {
    const standard = itemsByBasket?.find(e => e.basketType === STANDARD_BASKET);
    const autoreplenish = standard?.items.filter(item => item.isReplenishment);

    if (standard == null || autoreplenish.length === 0) {
        return { isAvailable: false };
    }

    return { isAvailable: true, items: autoreplenish };
}

function isPreBasketAvailable(basket) {
    // As of now, the only condition for showing PreBasket is that there is a Pickup/Bopis cart
    return getPickupFromStoreInfo(basket).isAvailable;
}

function calculateRootBasketType(basket) {
    // current rule is to render PreBasket if there are Bopis items
    if (isPreBasketAvailable(basket)) {
        return {
            currentRootBasketType: ROOT_BASKET_TYPES.PRE_BASKET,
            // currentMainBasketType will be set by user action on PreBasket
            currentMainBasketType: null
        };
    }

    return {
        currentRootBasketType: ROOT_BASKET_TYPES.MAIN_BASKET,
        // Default MAIN_BASKET_TYPE is DC because if we had BOPIS items, we would be rendering PreBasket
        currentMainBasketType: DC_BASKET
    };
}

function calculateAvailableCarts(basket) {
    const samedayInfo = getSameDayDeliveryInfo(basket);
    const standardInfo = getStandardShippingInfo(basket);
    const autoreplenishInfo = getAutoreplenishInfo(basket);

    return {
        getTotalItemsShippingBaskets: () => samedayInfo.items.length + standardInfo.items.length + autoreplenishInfo.items.length,
        [BOPIS_BASKET]: getPickupFromStoreInfo(basket),
        [SAMEDAY_BASKET]: samedayInfo,
        [STANDARD_BASKET]: standardInfo,
        [AUTOREPLENISH_BASKET]: autoreplenishInfo
    };
}

function getTargetUrl(item) {
    return item.sku.fullSizeSku && item.sku.fullSizeSku.targetUrl ? item.sku.fullSizeSku.targetUrl : item.sku.targetUrl;
}

module.exports = {
    calculateRootBasketType,
    calculateAvailableCarts,
    isPreBasketAvailable,
    getTargetUrl
};
